import axios from "axios";

export default {
  summary({ start_date, end_date, service, duration }) {
    let params = `duration=${duration}`;

    if (start_date, end_date) {
      params += `&start_date=${start_date}&end_date=${end_date}`;
    }

    if (service) {
      params += `&service=${service}`;
    }
    return axios.get(`marketplace_crm/feedback/stats?${params}`);
  },
  index(params) {
    return axios.get(`marketplace_crm/feedback?${params}`);
  },
};
